"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const button_1 = require("@kyruus/button");
const intl_1 = require("@kyruus/intl");
const ArrowLeft_1 = __importDefault(require("@kyruus/react-ikons/ArrowLeft"));
const Tracking_1 = require("../../lib/constants/Tracking");
const utils_1 = require("../../lib/utils");
const prop_types_1 = __importDefault(require("prop-types"));
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const BackToSearchButton = ({ backToSearchPageURL, searchMatchEnabled, isOrderBasedSchedulingFlow, track }) => {
    if (!(0, utils_1.isBackToSearchBtnRendered)({ backToSearchPageURL, searchMatchEnabled })) {
        return null;
    }
    const handleClick = () => {
        track(Tracking_1.userEvents.BACK_SEARCH_PAGE_BUTTON_CLICK_DESKTOP);
        window.history.back();
    };
    if (isOrderBasedSchedulingFlow) {
        return (react_1.default.createElement(styles_1.StyledButtonWithIcon, { icon: react_1.default.createElement(ArrowLeft_1.default, { "aria-hidden": "true" }), iconAlign: "left", mode: "flat", active: true, onClick: handleClick },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.goBack))));
    }
    return (react_1.default.createElement(button_1.ButtonLinkWithIcon, { icon: react_1.default.createElement(ArrowLeft_1.default, { "aria-hidden": "true" }), iconAlign: "left", mode: "flat", active: true, onClick: () => track(Tracking_1.userEvents.BACK_SEARCH_PAGE_BUTTON_CLICK_DESKTOP), href: backToSearchPageURL },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.backToSearch))));
};
BackToSearchButton.propTypes = {
    backToSearchPageURL: prop_types_1.default.string,
    searchMatchEnabled: prop_types_1.default.bool.isRequired,
    isOrderBasedSchedulingFlow: prop_types_1.default.bool.isRequired,
    track: prop_types_1.default.func.isRequired
};
exports.default = BackToSearchButton;
//# sourceMappingURL=BackToSearchButton.js.map